export default function WelcomeHeader({ name = "Arjun" }) {
  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">
        Welcome back, {name}
      </h1>
      <p className="text-gray-600 mt-1">
        Here's what's happening across your prototypes today.
      </p>
    </div>
  );
}